import CoreOnboardingView from '../../../../core/views/Onboarding'
// Import Onboarding steps
import NoMatchStartPlaying from './steps/NoMatchStartPlaying';
import MatchStartPlaying from './steps/MatchStartPlaying';
import './index.styl'

class OnboardingView extends CoreOnboardingView {
	showNoMatchStartPlaying() {
		this.showStep(NoMatchStartPlaying, 'bg-no-match-found');
	}

	showMatchStartPlaying() {
		this.showStep(MatchStartPlaying, 'bg-match-found');
	}
}

export default OnboardingView;